import Upload from './Upload';
import Dragger from './Dragger';

export { UploadProps, UploadListProps, UploadChangeParam } from './interface';
export { DraggerProps } from './Dragger';

Upload.Dragger = Dragger;
export default Upload;



// WEBPACK FOOTER //
// ./components/upload/index.tsx